import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getAuth } from 'firebase/auth';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only attach for Cloud Run Resume Homie API calls
    const isResumeHomieApi =
      req.url.startsWith('https://resume-homie-630346558823.us-central1.run.app');

    if (!isResumeHomieApi) {
      return next.handle(req);
    }

    const auth = getAuth();
    const user = auth.currentUser;

    // If not logged in, send as-is (backend will 401; UI can show sign-in prompt)
    if (!user) {
      return next.handle(req);
    }

    // Get token and attach Authorization header
    return from(user.getIdToken()).pipe(
      switchMap((token) => {
        const authedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        return next.handle(authedReq);
      })
    );
  }
}
